import locales from '../../locales.json';

const { FOOTER_TEXTS } = locales;

const Footer = () => (
  <footer className="app-footer">{FOOTER_TEXTS.brand}</footer>
);

export default Footer;
